import Classic from './classic';
import Inline from './inline';

const CK5 = {
	Inline,
	Classic
};
export default CK5;
